<template>
  <div class="app-container">
    <OtpInput v-if="!showPasswordCard" @submit="handleSubmitOtp" />

    <DoubleCheckPasswordCard
      v-else
      v-model="form.password"
      @submit="handleSubmitNewPassword"
    />

    <PayLoading
      :context="$t('passWordWaitText')"
      :is-show="loading"
    />
  </div>
</template>

<script>
import OtpInput from '@/views/OTP/OtpInput.vue'
import DoubleCheckPasswordCard from '@/components/DoubleCheckPasswordCard/index.vue'
import { updatePayPassword } from '@/api/me'
import { setTransactionPassMd5 } from '@/utils/safe'
import PayLoading from '@/components/PayLoading/index.vue'
export default {
  name: 'OTP',

  components: {
    PayLoading,
    OtpInput,
    DoubleCheckPasswordCard
  },

  data () {
    return {
      showPasswordCard: false,
      loading: false,
      form: {
        authCode: '',
        password: ''
      }
    }
  },

  methods: {
    handleSubmitOtp (otp) {
      this.form.authCode = otp

      this.showPasswordCard = true
    },

    handleSubmitNewPassword () {
      this.loading = true
      updatePayPassword({
        password: setTransactionPassMd5(this.form.password),
        authCode: this.form.authCode
      })
        .then(() => {
          this.showPasswordCard = false
          this.$router.replace({ name: 'Me' })
        })
        .finally(() => {
          this.loading = false
          this.form.password = ''
        })
    }
  }
}
</script>
